module.exports = __webpack_public_path__ + "img/soccer.be5030ca.webp";